export default "__VITE_ASSET__CbBuUca7__"